import './style.css';

import { Popover } from '@material-ui/core';
import { Button } from 'bz-core-controls';
import createReactClass from 'create-react-class';
import { date } from 'joi';
import $ from 'jquery';
import moment from 'moment';
import React from 'react';
import ReactDOM from 'react-dom';
import PublishMixin from '../../../../mixins/publish-mixin';
import FlatButton from '../../../general/flatButton';
import { OutlineButton } from '../../outline-button';
import Calendar from '../calendar';
import DateInput from './controls/date-input';

const DatePicker = createReactClass({
  displayName: 'DatePicker',
  mixins: [PublishMixin],

  getInitialState() {
    this._refs = {
      input: React.createRef(),
      popover: React.createRef()
    };

    return {};
  },

  getDefaultProps() {
    return {
      autoOpen: true,
      style: {},
      tabIndex: 0,
      format: 'DD/MM/YYYY',
      clickAwayable: false,
      className: '',
      onSelectNext: () => {},
      popoverProps: {},
      restrictFutureDate: false
    };
  },

  onChange(close, e) {
    if (this.props.restrictFutureDate && new moment().isBefore(e, 'days')) return;

    if (moment.isMoment(e)) e = e.toDate();

    if (close) {
      this.hide();
      this.props.onSelectNext();
    }

    let _val = this.get();
    if (!!_val && new moment(_val).isSame(e, 'day')) {
      //hack to deal with bluring causing false onChange
      return;
    }

    this.publish(e);
  },

  focus(e) {
    let input = this.getInputNode();
    if (input == null) {
      if (e != null) this.show(e);
      else this.onFocus();
    } else input.focus();
  },

  show(e) {
    let t = e.currentTarget;
    this.setState({
      open: true,
      anchorEl: t
    });
  },

  hide() {
    this.setState({
      open: false,
      anchorEl: null
    });
  },

  onKeyUp(e) {
    const { keyCode } = e;
    if (this.state.open && [9, 13, 27, 38].includes(keyCode)) {
      this.hide();
    } else if ([13, 40].includes(keyCode)) {
      this.show(e);
    }
  },

  onFocus(e) {
    const el = ReactDOM.findDOMNode(this);
    $(el).find('[tabIndex]').focus();
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!!this.props.autoOpen) setTimeout(() => this.show({ currentTarget: el }), 200);
    if (this.props.onFocus) this.props.onFocus();
  },

  onTabKeyDown(e) {
    if (e.keyCode === 9) {
      this.hide();
    }
  },

  getInputNode() {
    return this._refs.input.current;
  },

  onClearClick() {
    this.publish(null);
    this.hide();
  },

  render() {
    let value = '';
    let label, control;

    let className = `date-picker-control ${this.props.className}`;

    if (!!this.get()) {
      value = moment(this.get()).format(this.props.format);
    }

    if (this.props.readonly) {
      return (
        <div className={`${className} readonly`}>
          <div>
            <span>{value}</span>
          </div>
        </div>
      );
    }

    if (this.props.mode === 'input') {
      control = (
        <DateInput
          tabIndex={this.props.tabIndex}
          fullWidth={this.props.fullWidth}
          onClick={this.show}
          style={this.props.style}
          focus={this.props.focus}
          onFocus={this.onFocus}
          onBlur={this.props.onBlur}
          value={this.get()}
          onChange={this.onChange.bind(this, false)}
          onKeyUp={this.onKeyUp}
          onRequestClose={this.hide}
          ref={this._refs.input}
          placeholder="Please enter valid date"
          className={'bz-controls bz-datepicker ' + this.props.className}
          data-test-id="date-picker-input"
        />
      );
    } else {
      control = (
        <Button
          variant="outline"
          flat={true}
          small={true}
          forceClassName={true}
          tabIndex={0}
          className="bz-controls bz-datepicker"
          onClick={this.show}
          onKeyDown={this.onTabKeyDown}
          onFocus={this.onFocus}
          dataTestId="date-picker-button"
          {...this.props}
        >
          <span children={value || this.props.label} />
        </Button>
      );
    }

    const clearButton =
      this.props.field != null ? <FlatButton label="Clear" onClick={this.onClearClick} /> : null;

    const { className: popoverClassName = '' } = this.props.popoverProps;

    return (
      <div
        className={className}
        style={Object.assign({}, { height: '100%', display: 'inline-flex' }, this.props.style, {
          borderWidth: 0
        })}
        onKeyUp={this.onKeyUp}
      >
        <Popover
          ref={this._refs.popover}
          className={`bz-controls bz-datepicker ${popoverClassName}`}
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onRequestClose={this.hide}
        >
          <Calendar
            value={this.get()}
            onChange={this.onChange.bind(this, true)}
            onChangeNoClose={this.onChange.bind(this, false)}
            displayMode={this.props.displayMode}
            minYear={this.props.minYear}
            maxYear={new date()}
            clearButton={clearButton}
          />
        </Popover>
        {control}
      </div>
    );
  }
});

export default DatePicker;
export { DatePicker };
